import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  FlowerSubscriptionSettings,
  UpdateFlowerSubscriptionSettingsInput,
} from './flower-subscription-settings.types'

export interface FlowerSubscriptionSettingsScope {
  organizationId: OrganizationId
}

/** Query functions read only the key. */
type FlowerSubscriptionSettingsQueryContext = Pick<
  QueryFunctionContext<[FlowerSubscriptionSettingsScope]>,
  'queryKey'
>

export async function getFlowerSubscriptionSettings({
  queryKey: [{ organizationId }],
}: FlowerSubscriptionSettingsQueryContext) {
  return axios.get<FlowerSubscriptionSettings>(
    '/flower-subscription-settings',
    buildAdminRequestConfig({ organizationId })
  )
}

export async function updateFlowerSubscriptionSettings({
  organizationId,
  policyHtml,
  expectedPolicyVersion,
  platformHtml,
  expectedPlatformVersion,
}: UpdateFlowerSubscriptionSettingsInput & FlowerSubscriptionSettingsScope) {
  const payload =
    platformHtml !== undefined
      ? {
          platform_html: platformHtml,
          expected_platform_version: expectedPlatformVersion,
        }
      : {
          policy_html: policyHtml,
          expected_policy_version: expectedPolicyVersion,
        }

  return axios.put<FlowerSubscriptionSettings>(
    '/flower-subscription-settings',
    payload,
    buildAdminRequestConfig({ organizationId })
  )
}
